import { useEffect, useRef } from 'react';

const SKOOL_URL = 'https://skool.com/randomcollege';

export default function FloatingCTA() {
  const ref = useRef(null);
  useEffect(() => {
    function onScroll() {
      const footer = document.querySelector('.rc-footer');
      const cta = ref.current;
      if (!footer || !cta) return;
      const rect = footer.getBoundingClientRect();
      cta.style.opacity = rect.top < window.innerHeight + 80 ? '0' : '1';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <a ref={ref} href={SKOOL_URL} target="_blank" rel="noopener noreferrer" className="cta-fixed">
      Acceder a la Academia en Skool <span className="arrow">→</span>
    </a>
  );
}
